import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

const DateTimePickerField = ({id, name, label, handleDatePicker, helperText, defaultDate}) => {
    const [selectedDate, setSelectedDate] = useState((defaultDate !== undefined && defaultDate != null) ? new Date(defaultDate): null );

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justifyContent="space-around">
          <KeyboardDateTimePicker
            fullWidth
            id={id}
            name={name}
            label={label}
            value={selectedDate}
            variant='inline'
            inputVariant='outlined'
            autoOk={true}
            okLabel=''
            ampm={false}
            onChange={e => {setSelectedDate(e);handleDatePicker(e);}}
            animateYearScrolling
            format="yyyy-MM-dd HH:mm:ss"
            views={['year', 'month', 'date']}
            helperText={helperText}
          />
        </Grid>
    </MuiPickersUtilsProvider>
  );
};


export default DateTimePickerField;
